export default __webpack_public_path__ + "static/media/product6.f33d2cff.jpg";